<template>
  <v-dialog v-model="show" persistent>
    <v-card>
      <v-icon class="close" @click="$emit('cancel')">$sl-close</v-icon>
      <v-card-title>
        <span class="display-1">ÄNDRA BREDDNINGSREGLER VID {{ fromProfessionName }} > {{ professionName }}</span>
      </v-card-title>

      <v-card-text>
        <v-select
          :items="items"
          :label="`Kurser som krävs vid grundutbildning för breddning från ${fromProfessionName} till ${professionName}`"
          v-model="values"
          outlined
          clearable
          multiple
          chips
          deletable-chips
        >
        </v-select> 
      </v-card-text>

      <v-card-text>
        <v-select
          :items="Array.from({length: 48}, (_, index) => index + 1)"
          label="Kvalificeringstid"
          v-model="months"
          outlined
        >
        </v-select> 
      </v-card-text>


      <v-card-actions class="justify-end">
        <v-btn color="secondary" @click="$emit('cancel')">
          <v-icon>$sl-cancel</v-icon>Avbryt
        </v-btn>
        <v-btn class="icon" @click="save()">
          <v-icon>$sl-check</v-icon>Spara
        </v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<script>
import _get from 'lodash/get'
import find from 'lodash/find'
import filter from 'lodash/filter'
import API from '@/services/api'

export default {
  props: {
    show: Boolean,
    toProfession: Object
  },

  data: () => ({
    items: [],
    values: [],
    months: null
  }),

  watch: {
    show: {
      handler: function (newVal) {
        if (newVal) {
          this.initDialog()
        }
      }
    }
  },

  computed: {
    qLength() {
      const ql = _get(this, 'toProfession.data.length', null)
      return ql ? `${ql} månader` : 'Ej angiven'
    },

    selectedCourses() {
      const cs = _get(this, 'toProfession.data.requiredCourses', null)
      return cs ? cs : []
    },

    fromProfessionName() {
      if (!this.toProfession) return ''
      return _get(this, 'toProfession.fromProfessionName', null)

    },

    professionName() {
      if (!this.toProfession) return ''
      return _get(this, 'toProfession.professionName', null)

    }

  },

  methods: {
    initDialog() {
      if (!this.toProfession) return
      API.listPlainProfessionCourses(this.toProfession.profession)
        .then((res) => {
          this.items = res.data.map(i => {return {text: i.courseName, value: i.id } })
          this.values = this.selectedCourses.map(v => v.id)
          this.months = _get(this, 'toProfession.data.length', 36)
        })
        .catch((error) => {
          console.log(error);
        });

    },
  
    save() {
      let data = {
        profession: this.toProfession.profession,
        courses: filter(this.items, (i) => find(this.values, (v) => v === i.value)),
        months: this.months
      }

      this.$emit('save', data)
    }
  }
}
</script>

<style scoped>
  .lower {
    text-transform: lowercase;
  }
</style>